/* jshint esnext: true */

/**
 * Create a game character.
 */
const gameCharacter = {

	// A reference to the current game character.
	character: null,

	currentAnimation: null,

	animation: '',


	/**
	 * Create a new character and update the character reference.
	 */
	new: function( scene ) {

		// TODO: Swap this to use the stored game id.
		this.character = scene.add.sprite( 0, 0, 'character1' );

		// Set the origin to the middle of the character.
		this.character.setOrigin( 0.5, 0.8 );

		this.character.depth = 1;

		this.reset();

	},


	/**
	 * Reset the character properties.
	 */
	reset: function() {

		this.animate( 'idle' );

	},


	/**
	 * Position the character at the specified tile coordinates.
	 */
	position: function( x = 0, y = 0 ) {

		// Calculate the starting pixels based upon the grid start points.
		x = ( x * settings.tileWidth ) + ( settings.tileWidth / 2 );
		y = y + ( settings.tileWidth / 2 );

		this.character.x = x;
		this.character.y = y;

	},


	addAnimations: function( scene ) {

		// FPS for walking animations.
		const walk_speed = 8;

		scene.anims.create(
			{
				key: 'L',
				frames: scene.anims.generateFrameNumbers( 'character1', { frames: [ 7, 8, 9 ] } ),
				frameRate: walk_speed,
				yoyo: true,
				repeat: -1
			}
		);

		scene.anims.create(
			{
				key: 'R',
				frames: scene.anims.generateFrameNumbers( 'character1', { frames: [ 7, 8, 9 ] } ),
				frameRate: walk_speed,
				yoyo: true,
				repeat: -1
			}
		);

		scene.anims.create(
			{
				key: 'U',
				frames: scene.anims.generateFrameNumbers( 'character1', { frames: [ 4, 5, 6 ] } ),
				frameRate: walk_speed,
				yoyo: true,
				repeat: -1
			}
		);

		scene.anims.create(
			{
				key: 'D',
				frames: scene.anims.generateFrameNumbers( 'character1', { frames: [ 2, 1, 3 ] } ),
				frameRate: walk_speed,
				yoyo: true,
				repeat: -1
			}
		);

		scene.anims.create(
			{
				key: 'idle',
				frames: scene.anims.generateFrameNumbers( 'character1', { frames: [ 0, 1 ] } ),
				frameRate: 3,
				repeat: -1
			}
		);

		scene.anims.create(
			{
				key: 'win',
				frames: scene.anims.generateFrameNumbers( 'character1', { frames: [ 10, 11, 12 ] } ),
				frameRate: 7,
				repeat: 0
			}
		);

		scene.anims.create(
			{
				key: 'lose',
				frames: scene.anims.generateFrameNumbers( 'character1', { frames: [ 13, 14, 15 ] } ),
				frameRate: 5,
				repeat: 0
			}
		);

	},


	/**
	 * Animate the current character.
	 */
	animate: function( animation ) {

		if ( animation !== this.animation ) {

			this.character.anims.play( animation );

		}

		this.animation = animation;

	},


	/**
	 *
	 */
	setAnimation: function( animation = null ) {

		if ( this.animation === animation ) {
			return;
		}

		if ( 'level_complete' === gameplay.state ) {

			gameCharacter.character.setFlipX( false );
			this.animate( 'win' );
			return;

		}

		if ( 'level_end' === gameplay.state ) {

			gameCharacter.character.setFlipX( false );
			this.animate( 'lose' );
			return;

		}

		if ( !animation || null === animation ) {

			this.animate( 'idle' );
			return;

		}

		this.animate( animation );

	},

};